// @flow

export function retryUntilTruthy(fn: () => Promise<any>, milliseconds: number) {
  return fn().then(value => {
    if (value) {
      return value;
    } else {
      return wait(milliseconds).then(() => retryUntilTruthy(fn, milliseconds));
    }
  });
}

export function wait(milliseconds: number): Promise<number> {
  return new Promise((resolve) => {
    window.setTimeout(resolve, milliseconds);
  });
}

export function log<T>(val: T): T {
  console.log(val);
  return val;
}
